// extracted by mini-css-extract-plugin
export default {"hidden":"headingH1_hidden__qNxj1","monospace":"headingH1_monospace__uOyqY","wFull":"headingH1_wFull__qvSur","ellipsis":"headingH1_ellipsis__tJ50A","title":"headingH1_title__Ygv+E"};